import { render } from "./TicketTestRoom.vue?vue&type=template&id=2d576e5e&scoped=true"
import script from "./TicketTestRoom.vue?vue&type=script&lang=js"
export * from "./TicketTestRoom.vue?vue&type=script&lang=js"

import "./TicketTestRoom.vue?vue&type=style&index=0&id=2d576e5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d576e5e"]])

export default __exports__